import React from 'react';

export const FilesDelete = ({ fill = '#E04E2A', width = 16, height = 16 }) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11.3333 14.6668H4.66667C3.93029 14.6668 3.33333 14.0699 3.33333 13.3335V4.66683H2V3.3335H4.66667V2.66683C4.66667 1.93045 5.26362 1.3335 6 1.3335H10C10.7364 1.3335 11.3333 1.93045 11.3333 2.66683V3.3335H14V4.66683H12.6667V13.3335C12.6667 14.0699 12.0697 14.6668 11.3333 14.6668ZM4.66667 4.66683V13.3335H11.3333V4.66683H4.66667ZM6 2.66683V3.3335H10V2.66683H6ZM10 12.0002H8.66667V6.00016H10V12.0002ZM7.33333 12.0002H6V6.00016H7.33333V12.0002Z"
            fill={fill}
        />
    </svg>
);
